import { addCategory } from '../../../../actions/siteadmin/Category/addCategory';
import { toastr } from 'react-redux-toastr';

async function submit(values, dispatch) {
    if (!values.categoryImage) {
        toastr.error('Error!', "Category image is required.");
        return;
    }

    await dispatch(
        addCategory(
            values.categoryName,
            values.isActive,
            values.categoryImage,
            values.description,
            values.deliveryType,
            values.id
        )
    )
}

export default submit;